import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import Container from '../../containers/Asset/Container';

export default class AssetsRenderer {
    constructor(store) {
        this.store = store;
    }

    ensure(id) {
        let container = global.document.getElementById(`inplayer-${id}`);

        if (!container) {
            throw new Error(`Can't find element with id ${id}`);
        }

        return container;
    }

    ensureElement(asset) {
        let container = '<div></div>';
        let msg = '';
        if (asset.external) {
            container = global.document.getElementById(
                `inplayer-${asset.external.type}-${asset.external.id}`
            );
            msg = `Can't find element with id ${asset.external.type}_${
                asset.external.id
            }`;
        } else {
            container = global.document.getElementById(`inplayer-${asset.id}`);
            msg = `Can't find element with id ${asset.id}`;
        }

        if (!container) {
            throw new Error(msg);
        }

        return container;
    }

    render(asset, isExternal = false) {
        const container = this.ensureElement(asset);

        ReactDOM.render(
            <Provider store={this.store}>
                <Container {...asset} isExternal={isExternal} />
            </Provider>,
            container
        );
    }

    remove(containerId) {
        try {
            const container = this.ensure(containerId);
            if (container) {
                ReactDOM.unmountComponentAtNode(container);
            }
        } catch (e) {
            // do nothing if container doesn't exist
        }
    }
}



// WEBPACK FOOTER //
// ./src/ui/renderers/assets.js